import domWrap from "../utils/domWrap";
import h from "../utils/htm";

export default async explore => { // 'comp-truck-explore'
	const { default: Swiper } = await import('swiper'),
			innerContent = explore.querySelector('inner-content'),
			container = domWrap(innerContent),
		links = [...container.querySelectorAll(':scope > [swiper-link], a')];
	
	if (!innerContent) return;
	container.setAttribute('count', links.length);
	links.forEach(link => {
		link.classList.add('swiper-slide');
		link.addEventListener('click', e => {
			e.preventDefault();
			if (!link.getAttribute('jwpid') && link.getAttribute('href') != null) {
				window.location.href = link.getAttribute('href');
			}	
		});
	});
	container.classList.add('swiper-container');
	container.wrapInner(h('div class="swiper-wrapper"').Node);
	container.appendChild(h('div class="swiper-pagination"')('div class="swiper-button-prev"')('div class="swiper-button-next"').Node);
	
	new Swiper(container,{
		slidesPerView: 'auto',
		centeredSlides: false,
		spaceBetween: 20,
		slidesOffsetBefore: 20,
		slidesOffsetAfter: 20,
		effect: 'slide',
		speed: 600,
		pagination: container.querySelector('.swiper-pagination'),
		paginationClickable: true,
		nextButton: container.querySelector('.swiper-button-next'),
		prevButton: container.querySelector('.swiper-button-prev'),
		breakpoints: {
			767: {
			slidesPerView: 'auto',
			spaceBetween: 10
			}
		}
	});
};